import OrderMethodCOD from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/OrderMethodCOD';
import OrderMethodDeliveryType from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/OrderMethodDeliveryType';
import OrderMethodPickupType from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/OrderMethodPickupType';

import { orderMethodsState } from 'components/pages/dashboard/ParcelOrder/ParcelOrder';
import { priceTypeBranch } from 'components/pages/dashboard/parcelOrderForBranch/components copy/BranchOrder/BranchParcelOrderPrice';
import OrderMethodPaymentType from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderMethods/components/OrderMethodPaymentType';
import { omOrderServices, packageCreate } from 'global/Models/omOrderModel';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getBranchesWorkingTimes } from 'redux/reducer/ParcelOrder/getBranchesWorkingTimes';
import { getDeliveryTypes } from 'redux/reducer/ParcelOrder/getDeliveryTypes';
import { getPaymentTypes } from 'redux/reducer/ParcelOrder/getPaymentTypes';
import { getPickupTypes } from 'redux/reducer/ParcelOrder/getPickupTypes';
import { getServices } from 'redux/reducer/ParcelOrder/getServices';
import { RootState, store } from 'redux/store';
import OrderMethodServiceType from './components/OrderMethodServiceType';

interface IOrderMethods {
  orderMethods: orderMethodsState;
  setOrderMethods: React.Dispatch<React.SetStateAction<orderMethodsState>>;
  orderServices: omOrderServices;
  setOrderServices: React.Dispatch<React.SetStateAction<omOrderServices>>;
  priceList?: priceTypeBranch;
  packages: packageCreate[];
  setPackages: React.Dispatch<React.SetStateAction<packageCreate[]>>;
  priceLoading?: boolean;
  serviceLoading?: boolean;
  cashAmount: number | undefined;
  setCashAmount: (_val: number) => void;
}

const BranchOrderMethods: FC<IOrderMethods> = ({
  orderMethods,
  setOrderMethods,
  orderServices,
  setOrderServices,
  priceList,
  packages,
  setPackages,
  serviceLoading,
  cashAmount,
  setCashAmount,
}) => {
  //states
  const { deliveryTypes, paymentTypes, pickupTypes, branchesWorkingTime, service } = useSelector((state: RootState) => state.parcelOrder);

  //effect
  useEffect(() => {
    !deliveryTypes && store.dispatch(getDeliveryTypes());
    !paymentTypes && store.dispatch(getPaymentTypes());
    !pickupTypes && store.dispatch(getPickupTypes());
    !branchesWorkingTime && store.dispatch(getBranchesWorkingTimes());
    !service && store.dispatch(getServices());

    if (deliveryTypes && paymentTypes && pickupTypes && service && branchesWorkingTime) {
      setOrderMethods({
        ...orderMethods,
        deliveryTypeId: 10,
        paymentTypeId: 20,
        pickupTypeId: pickupTypes[1].id,
        selectedDate: branchesWorkingTime[0].date,
        selectedFromHour: branchesWorkingTime[0].periods[0].startTime,
        selectedToHour: branchesWorkingTime[0].periods[0].endTime,
        serviceId: service[0].id,
      });
    }
  }, [deliveryTypes, paymentTypes, pickupTypes]);

  //functions
  const handleChange = (values: Partial<orderMethodsState>) => setOrderMethods((prevState) => ({ ...prevState, ...values }));

  return (
    <div>
      <div className='pt-6'>
        <OrderMethodServiceType setOrderServices={setOrderServices} orderServices={orderServices} priceLoading={serviceLoading} packages={packages} />
        {/* <OrderMethodWorkingTime
          orderServices={orderServices}
          handleChange={handleChange}
          selectedDate={orderMethods.selectedDate}
          selectedFromHour={orderMethods.selectedFromHour}
          selectedToHour={orderMethods.selectedToHour}
        /> */}
        <OrderMethodPickupType pickupTypeId={orderMethods.pickupTypeId} handleChange={handleChange} packages={packages} />
        <OrderMethodDeliveryType deliveryTypeId={orderMethods.deliveryTypeId} handleChange={handleChange} packages={packages} />
        <OrderMethodCOD orderMethods={orderMethods} handleChange={handleChange} packages={packages} setPackages={setPackages} haveCOD={orderMethods.haveCOD} />
        <OrderMethodPaymentType orderMethods={orderMethods} handleChange={handleChange} priceList={priceList} setCashAmount={setCashAmount} cashAmount={cashAmount} />
      </div>
    </div>
  );
};

export default BranchOrderMethods;
